import React from 'react';
import ThirdPartyAccountCreateCard from '../components/ThirdPartyAccountCreateCard';

export default function ThirdPartyAccountCreateCardScreen() {
  return <ThirdPartyAccountCreateCard />;
}
